import { render, staticRenderFns } from "./ExibirAtoInfralegal.vue?vue&type=template&id=5c7b8bdc"
import script from "./ExibirAtoInfralegal.vue?vue&type=script&lang=js"
export * from "./ExibirAtoInfralegal.vue?vue&type=script&lang=js"
import style0 from "./ExibirAtoInfralegal.vue?vue&type=style&index=0&id=5c7b8bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports